import BaseService from '@/services/BaseService'

class StorageCardService {

    constructor() {
        this._httpService = new BaseService();
    }

    getStorageCards() {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/storage-card-management/storage-cards`,
            method: 'GET'
        }
        console.info('get storage-cards')
        return this._httpService.service(settings)
    }

    putStorageCard(storageCard) {
        let settings = {
            baseURL: `${this._httpService.baseUrl}/storage-card-management/storage-cards/${storageCard.id}`,
            method: 'PUT',
            data: storageCard
        }
        return this._httpService.service(settings)
    }
}

export default StorageCardService